import React, { useEffect, useState } from 'react';
import { DashboardTemplate } from '../../components/templates/DashboardTemplate.tsx';
import {
  Box,
  VStack,
  Text,
  Button,
  useToast,
  Heading,
  Flex,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react';
import { Input, PhoneInput } from '@partiu/ui/components/atoms/Input.tsx';
import { Labeled } from '@partiu/ui/components/molecules/Labeled.tsx';
import { toPhone } from '@partiu/ui/formatters.ts';
import { FaWhatsapp } from 'react-icons/fa';
import { useAgreementLandingInfo, useUpdateAgreementLandingInfoMutation } from '@partiu/api/dashboard/hooks.ts';

export default function CustomerCentralPage() {
  const toast = useToast();
  const { data, isLoading } = useAgreementLandingInfo();
  const mutation = useUpdateAgreementLandingInfoMutation({
    onSuccess: () => {
      toast({
        title: 'Sucesso!',
        description: 'Canal de atendimento atualizado com sucesso.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    },
    onError: () => {
      toast({
        title: 'Erro ao salvar',
        description: 'Não foi possível salvar o canal de atendimento. Tente novamente.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    },
  });

  const [cellphone, setCellphone] = useState('');
  const [contactLink, setContactLink] = useState('');

  useEffect(() => {
    if (!data) return;
    setCellphone(toPhone(data.cellphone || ''));
    setContactLink(data.contactLink || '');
  }, [data]);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate({ cellphone: cellphone.trim(), contactLink: contactLink.trim() });
  };

  return (
    <DashboardTemplate>
      <Flex direction="column" align="center" w="100%" p={4}>
        <Box w={{ base: '100%', md: '80%', lg: '70%' }} mb={8} textAlign="center">
          <Heading as="h1" size="xl" mb={2} color="primary.700">
            Central do Cliente
          </Heading>
          <Text fontSize="lg" color="gray.600">
            Configure aqui os principais canais e informações de atendimento ao seu cliente. Novas opções serão
            adicionadas em breve!
          </Text>
        </Box>
        <Accordion allowToggle w={{ base: '100%', md: '80%', lg: '70%' }}>
          <AccordionItem borderRadius={12} boxShadow="md" mb={4}>
            <h2>
              <AccordionButton>
                <Box fontWeight={'bold'} flex="1" textAlign="left" display="flex" alignItems="center" gap={2}>
                  <Box as={FaWhatsapp} color="green.500" boxSize={6} />
                  WhatsApp de Atendimento
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <Text color="gray.500" fontSize="sm" mb={4}>
                Defina o celular de atendimento. Se o atendimento não for pelo WhatsApp (ou usar um link próprio),
                informe o link de redirecionamento — ele tem prioridade sobre o número.
              </Text>
              <Box as="form" w="100%" maxW="600px" onSubmit={handleSave}>
                <VStack spacing={3} w="100%">
                  <Labeled label="Celular / WhatsApp">
                    <PhoneInput
                      placeholder="(11) 9 9999-9999"
                      value={cellphone}
                      onChange={(e) => setCellphone(e.target.value)}
                      isDisabled={isLoading || mutation.isLoading}
                    />
                  </Labeled>
                  <Labeled label="Link de redirecionamento (opcional)">
                    <Input
                      placeholder="https://wa.me/5511999999999 ou link de outro canal"
                      value={contactLink}
                      onChange={(e) => setContactLink(e.target.value)}
                      type="url"
                      isDisabled={isLoading || mutation.isLoading}
                    />
                  </Labeled>
                  <Button
                    colorScheme="green"
                    type="submit"
                    isLoading={mutation.isLoading}
                    alignSelf={{ base: 'stretch', md: 'flex-end' }}
                    minW="160px"
                    size="md"
                  >
                    Salvar
                  </Button>
                </VStack>
              </Box>
            </AccordionPanel>
          </AccordionItem>
          {/* Outros Accordions/cards de configuração podem ser adicionados aqui futuramente */}
        </Accordion>
      </Flex>
    </DashboardTemplate>
  );
}
